import { render, staticRenderFns } from "./TidyIcon.vue?vue&type=template&id=527f8ef6&"
import script from "./TidyIcon.vue?vue&type=script&lang=js&"
export * from "./TidyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports